import React from 'react';

import { tv } from '../../tv';

/**
 * A key, or a short chord, the way it is printed on a keyboard: Enter to
 * send, Esc to close. It is Code's chip (the mono face, the quiet wash, the
 * small radius) squared up to a 20px key so a single glyph reads as a cap
 * rather than a character, and it rides the surrounding text's colour and
 * step like Code does. One key per element; a chord is several side by side,
 * and the gap between them is the parent's.
 */
export interface KbdProps {
  /** What is printed on the key. */
  children: React.ReactNode;
  id?: string;
}

const kbdStyles = tv({
  base: [
    'ck:inline-flex ck:h-5 ck:min-w-5 ck:items-center ck:justify-center ck:px-1',
    'ck:font-mono ck:text-code ck:font-semibold ck:bg-neutral-a-3 ck:rounded-2',
  ],
});

export const Kbd = React.forwardRef<HTMLElement, KbdProps>(function Kbd({ children, id }, ref) {
  return (
    <kbd ref={ref} id={id} className={kbdStyles()} data-component="kbd">
      {children}
    </kbd>
  );
});
